import React, { Component } from 'react';
import ModalConnection from './ModalConnectionSubscribe';
import {doSignOut} from '../authDB';


class App extends Component {
    show_connection(){
        this.refs.ModalConnection.handleShow();
    console.log(this.refs)
    }
    Deconx(){
      localStorage.removeItem('user')
      doSignOut().then(()=>{
        window.parent.location = window.parent.location.href;
    
      })
    }
  render() {
    return (
   <div>
        <header className="header">
            <div className="container">
                <div className="menubar">
                    <div className="row">
                        <div className="col-md-12">
                            <nav className="navbar navbar-static-top">
                             <div className="navbar-header">
                                    <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" aria-expanded="false">
                                        <span className="sr-only">Toggle navigation</span>
                                        <span className="icon-bar"></span>
                                        <span className="icon-bar"></span>
                                        <span className="icon-bar"></span>
                                    </button>
                                    <a className="navbar-brand" href="/">
                                        <img src="/images/logo.png" className="img-responsive" alt="logo"/>
                                    </a>
                                </div>                      
     <div className="collapse navbar-collapse ">
                                    <ul className="nav navbar-nav navbar-right">
                                    
                                    <li className="res-btn">
                                          {(JSON.parse(localStorage.getItem('user')))?  <button onClick={()=>this.Deconx()} className="book-btn">Déconnection</button>:<button onClick={()=>this.show_connection()} className="book-btn">Connexion</button>}
                                    </li>
                                    </ul>
                                    <ul className="nav navbar-nav navbar-right" id="main-menu">

                                    <li className="">

                                         <a  href="/">
                                                Accueil
                                         </a>
                                    </li>
                                        <li className="active">
                                            <a  href="/about">À propos</a>
                                        </li>
                                        <li className="">
                                            <a  href="/order">Menu</a>                                          
                                        </li>
                                        {(JSON.parse(localStorage.getItem('user')))?  <li className="">
                                            <a  href="/historique">Historique</a>
                                        </li>:null       }     
                                        {(JSON.parse(localStorage.getItem('user')))?   <li className="">
                                            <a href="/loyalty">
                                            Fidélité
                                            </a>
                                        </li>  :null       } 
                                        <li className="">
                                            <a   href="/Blog">
                                                Blog
                                            </a>
                                        </li>     
                                                          
                                        <li className="">
                                            <a   href="/contact">
                                                Contact
                                            </a>
                                        </li>  
                                                                           
                                    </ul>
                                </div>  
                            </nav>
                        </div>
                    </div>
                </div>

            </div>
            <div className="mobile-menu" data-logo="/images/logo.png">


            </div>



        </header>
       
        <section className="page-title">
    <div className="container">
        <h2 className="title">
        À propos de Nous
        </h2>
        <ul className="brdcrumb clearfix">
            <li>
                <a href="/">Accueil</a>
            </li>
            <li className="current">
            À propos
            </li>
        </ul>
    </div>
</section>

<section className="page-section section-padding abt-page-bg">
    <div className="container">
        <div className="row">

            <div className="col-md-6">

                <div className="abt-content">
                    <p>
                    Bistro 73, un rêve qui se concrétise, 1300 mètres carrés dédiés à la restauration en buffet et à la carte, 
                    à la boulangerie et à la pâtisserie dans la pure tradition française. 
                    Le premier espace totalement non-fumeur de la ville.
                    </p>
                    <ul className="food-list">
                        
                    </ul>
                    <div className="row">
                        <div className="col-xs-11 col-sm-8 p-top20">
                            <h3 className="main-title text-left">
                                <span>
                                Pourquoi nous choisir
                                </span>
                            </h3>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-xs-6 sm-full sm-text-center">
                            <div className="quality-box">
                                <div className="icon">
                                    <i className="flaticon-tray-1"></i>
                                </div>

                                <h4 className="quality-title"> Véritable Grill & Feu de Bois</h4>
                                <p>
                                Nous cuisons vos grillades au grill au goût authentique du BBQ
 ou au four au Feu de bois, pour une saveur inimitable.
                                </p>

                            </div>
                        </div>
                        <div className="col-xs-6 sm-full sm-text-center">
                            <div className="quality-box">
                                <div className="icon">
                                    <i className="flaticon-chef"></i>
                                </div>

                                <h4 className="quality-title">Une Cuisine saine & un fait maison authentique</h4>
                                <p>
                                Avec l’amour que nous portons à la cuisine saine, élaboré avec des produits frais et un fait maison authentique.
                                </p>

                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-6 sm-full sm-text-center">
                            <div className="quality-box">
                                <div className="icon">
                                    <div className="icon">
                                        <i className="flaticon-tray-1"></i>
                                    </div>

                                </div>

                                <h4 className="quality-title">Viande de qualité  & Poissons Frais</h4>
                                <p>
                                Nous choisissons nos produits avec soin et les parties les plus nobles de l'animal. Les morceaux de choix et d'excellence.
                                </p>
                            </div>
                        </div>
                        <div className="col-xs-6 sm-full sm-text-center">
                            <div className="quality-box">
                                <div className="icon">
                                    <div className="icon">
                                        <i className="flaticon-chef"></i>
                                    </div>
                                </div>

                                <h4 className="quality-title">Notre concept Le Tour Du Monde</h4>
                                <p>
                                Vous apporté ce qui se fait de meilleurs à travers un voyage culinaire des meilleures recettes du monde entier.
                                </p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div className="col-md-6">
                <div className="row">
                    <div className="col-xs-11 col-sm-6">
                        <h3 className="main-title text-left">
                            <span>
                            Notre histoire
                            </span>
                        </h3>
                    </div>
                </div>

                <ul className="timeline">
                    <li>

                        <img src="images/about/timeline.jpg" className="featured-pic" alt=""/>

                        <h4 className="title"><a href="#">Où tout cela a commencé…</a></h4>
                        <p>
                            Consectetuer adipiscing elit. Aenean commodo eg cos dolor. Aenean massa. Cum sociis natoq
                            penat us magnis dis parturient montes, nascet ridiculus mus. Donec quam felis, ultricies
                            nec, pellentesque eu, pretium quis, sem.
                        </p>

                    </li>
                    <li>

                        <img src="images/about/timeline2.jpg" className="featured-pic" alt=""/>

                        <h4 className="title"><a href="#">QUELQUE CHOSE POUR TOUT LE MONDE</a></h4>
                        <p>
                            Consectetuer adipiscing elit. Aenean commodo eg cos dolor. Aenean massa. Cum sociis natoq
                            penat us magnis dis parturient montes, nascet ridiculus mus. Donec quam felis, ultricies
                            nec, pellentesque eu, pretium quis, sem.
                        </p>

                    </li>
                    <li>

                        <img src="images/about/timeline3.jpg" className="featured-pic" alt=""/>

                        <h4 className="title"><a href="#">Notre nourriture, nos bons moments</a></h4>
                        <p>
                            Consectetuer adipiscing elit. Aenean commodo eg cos dolor. Aenean massa. Cum sociis natoq
                            penat us magnis dis parturient montes, nascet ridiculus mus. Donec quam felis, ultricies
                            nec, pellentesque eu, pretium quis, sem.
                        </p>

                    </li>
                    <li>

                        <img src="images/about/timeline4.jpg" className="featured-pic" alt=""/>

                        <h4 className="title"><a href="#">Découvrez notre histoire</a></h4>
                        <p>
                            Consectetuer adipiscing elit. Aenean commodo eg cos dolor. Aenean massa. Cum sociis natoq
                            penat us magnis dis parturient montes, nascet ridiculus mus. Donec quam felis, ultricies
                            nec, pellentesque eu, pretium quis, sem.
                        </p>

                    </li>
                </ul>
            </div>

        </div>
    </div>
</section>





<section className="newsletter-section section-padding">
    <div className="container">
        <div className="row">
            <div className="col-md-7">
                <h2 className="newsletter-title ">
                Abonnez-vous à notre newsletter
                </h2>
            </div>
            <div className="col-md-5">

                <form action="#" method="post" className="news-form">
                    <i className="fa fa-envelope-o"></i>
                    <input type="text" placeholder="Entrez votre adresse email" className="form-control"/>
                    <button type="submit" className="btn-submit">Abonnez</button>
                </form>
            </div>
        </div>
    </div>
</section>

   
   
   <ModalConnection ref="ModalConnection"/>

    </div>


       
   
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/container/About.js